import { Radio } from "antd";

export default function HRadioButton({ options, selectedValue, onChange, size }) {
  return (
    <Radio.Group size={size} buttonStyle="solid" borderColorDisabled className="hs-radio-group gap-1" bordered={false} onChange={onChange}>
      {options.map((option, index) => (
        <Radio.Button
          key={index}
          className={`hs-radio-btn hs-fs-small m-1 ${selectedValue === option.value ? "hs-radio-active" : "hs-radio-inactive"}`}
          value={option.value}
          data-cy={option.dataCy}
        >
          {option.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
}
